import { Injectable } from '@angular/core';
import { RouterState } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { ApplicationConfiguration, CategoryApplicationsStoreActions, DeviceStoreSelectors } from '@era/stores';

@Injectable()
export class DeviceConfiguredApplicationsResolver {
  constructor(
    private readonly store: Store<ApplicationConfiguration>,
    private readonly routeStore: Store<RouterState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routeStore.select(DeviceStoreSelectors.selectDeviceByCurrentAppleDevice).pipe(
      filter((device) => device !== undefined),
      tap((device) => {
        if (device.brandUniqueId !== undefined) {
          this.store.dispatch(
            CategoryApplicationsStoreActions.DeviceConfiguredApplicationsResolverActions.categoryApplicationsRequested({
              id: device.brandUniqueId,
              categoryType: 'Brand',
            })
          );
        }

        if (device.locationUniqueId !== undefined) {
          this.store.dispatch(
            CategoryApplicationsStoreActions.DeviceConfiguredApplicationsResolverActions.categoryApplicationsRequested({
              id: device.locationUniqueId,
              categoryType: 'Location',
            })
          );
        }

        if (device.roomUniqueId !== undefined) {
          this.store.dispatch(
            CategoryApplicationsStoreActions.DeviceConfiguredApplicationsResolverActions.categoryApplicationsRequested({
              id: device.roomUniqueId,
              categoryType: 'Room',
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
